import { useEcho } from '@laravel/echo-react';
import { useCallback } from 'react';
import type { ToolbarNotification } from './notificationTypes';

type ToolbarNotificationsBroadcastProps = {
	appName: string;
	userId: string | number;
	onNotification: (payload: ToolbarNotification) => void;
};

function directNotificationsChannel(appName: string, userId: string | number) {
	return `directNotifications.${appName}.${userId}`;
}

/**
 * Subscribes to the same private channel and event as `toolbar/js/websocket/index.js`.
 */
export function ToolbarNotificationsBroadcast({ appName, userId, onNotification }: ToolbarNotificationsBroadcastProps) {
	const channel = directNotificationsChannel(appName, userId);

	const handler = useCallback(
		(e: ToolbarNotification) => {
			onNotification(e);
		},
		[onNotification]
	);

	useEcho<ToolbarNotification>(channel, '.notification', handler, [channel, handler], 'private');

	return null;
}
